module.exports = __webpack_public_path__ + "media/images/site/map_marker-18c22bfc143619c44ab8d4ddc5e3afe0.png";